import { render, staticRenderFns } from "./CollectRecharge.vue?vue&type=template&id=79212f60&scoped=true"
import script from "./CollectRecharge.vue?vue&type=script&lang=js"
export * from "./CollectRecharge.vue?vue&type=script&lang=js"
import style0 from "./CollectRecharge.vue?vue&type=style&index=0&id=79212f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79212f60",
  null
  
)

export default component.exports